export const DEFAULT_SERVER_TIMEOUT_MS = 300_000;

export function resolveExecutionTimeoutMs(timeoutMs?: number): number | null {
  if (timeoutMs === 0) return null;
  if (typeof timeoutMs === "number" && Number.isFinite(timeoutMs) && timeoutMs > 0) {
    return timeoutMs;
  }
  return DEFAULT_SERVER_TIMEOUT_MS;
}

export function createExecutionAbortController(timeoutMs?: number): {
  controller: AbortController;
  cleanup: () => void;
} {
  const controller = new AbortController();
  const effectiveTimeoutMs = resolveExecutionTimeoutMs(timeoutMs);
  const timeoutId = effectiveTimeoutMs == null
    ? null
    : setTimeout(() => controller.abort(), effectiveTimeoutMs);

  return {
    controller,
    cleanup: () => {
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
    },
  };
}

export function withExecutionTimeoutSignal(signal: AbortSignal, timeoutMs?: number): AbortSignal {
  const effectiveTimeoutMs = resolveExecutionTimeoutMs(timeoutMs);
  if (effectiveTimeoutMs == null) {
    return signal;
  }

  return AbortSignal.any([signal, AbortSignal.timeout(effectiveTimeoutMs)]);
}
